import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { PATHS } from '../../config/consts';
import actions, { selectors as commonSelectors } from '../../modules/common';
import GTCItem from './GTCItem';
import GTCLayout from './GTCLayout';
import GTCWrapper from './GTCWrapper';
import { getGTCListData } from './helper';
import messages from './messages';

export interface IGTCData {
  description: string;
  id: number;
  name: string;
  nextId: number;
  path: string;
  versions: IGTCData[];
}

export function GTCPage() {
  const dispatch = useDispatch();
  const gtcData = useSelector(commonSelectors.getGTCList);

  useEffect(() => {
    dispatch(actions.loadGTCList());
  }, []);

  return (
    <GTCLayout>
      <GTCWrapper title={<FormattedMessage {...messages.gtcTitle} />}>
        {getGTCListData(gtcData).map((item: IGTCData) => (
          <GTCItem
            basePath={PATHS.GTC_PAGE_DETAIL}
            description={item.description}
            key={item.id}
            name={item.name}
            versions={item.versions}
          />
        ))}
      </GTCWrapper>
    </GTCLayout>
  );
}
